import moment from 'moment'
import EventBus from '@/components/mixins/event-bus-mixin'
import CommonOptionsMixin from '@/components/mixins/common-options-mixin'
import DurationInput from '@/components/common/duration-input/duration-input-tmpl'
import FontList from '@/components/common/font-list/font-list-tmpl'
import MediaList from '@/components/common/media-list/media-list-tmpl'
import TagsMenuItem from '@/components/common/tags/tags-tmpl'
import TimepickerWithTimeformat from '@/components/common/timepicker-with-timeformat/timepicker-with-timeformat-tmpl'
import schedulePlaytimeMenuItem from '@/components/common/media-menu/schedule-playtime-menu-item/schedule-playtime-menu-item-tmpl'
import AlignElementsMenuItem from '@/components/common/align-elements-menu/align-elements-menu-tmpl'
import AuthMixin from '@/components/mixins/auth-mixin'
import UnsavedDataMixin from '@/components/mixins/unsaved-data-mixin'
import { v4 as uuidv4 } from 'uuid'
import _ from 'lodash'
import { mapState } from 'pinia'
import { useGlobalStore } from '@/pinia/stores/globalStore'

const FONT_WEIGHT_BOLD = '700';
const FONT_WEIGHT_REGULAR = '400';
const FONT_ITALIC = 'italic';
const FONT_NORMAL = 'normal';

export default {
  name: 'editPprojectTemplateMenu',
  inject: [
    '$currentUser',
    '$utils',
    '$dataStore',
    '$api',
    '$apiError',
    '$filtersRepository'
  ],
  components: { FontList, MediaList, TagsMenuItem, schedulePlaytimeMenuItem, DurationInput, TimepickerWithTimeformat, AlignElementsMenuItem },
  props: {
    projectTemplateActionProp: {
      type: String,
      default () { return '' }
    },
    openMediaPickerDialogProp: {
      type: Object,
      default () { return null }
    },
    projectTemplateProp: {
      type: Object,
      default () { return {} }
    },
    screenIndexProp: {
      type: Number,
      default () { return 0 }
    },
    editTemplateFrameTabProp: {
      type: String,
      default () { return '' }
    },
    tagsSummaryForSuggestionsProp: {
      type: Array,
      default () { return [] }
    },
    isAlignElementVisible: {
      type: Boolean,
      default () { return false }
    }
  },
  watch: {
    projectTemplateActionProp (newVal) {
      this.projectTemplateAction = newVal
    },
    projectTemplateProp (newProjectTemplateDataVal) {
      this.setDefaultData(newProjectTemplateDataVal)
    },
    openMediaPickerDialogProp (newVal) {
      if (!newVal) return
      this.openMediaPickerDialog(newVal.menuItemId)
    },
    screenIndexProp (newVal) {
      this.screenIndex = newVal
      this.setCityListOptionFromCurrentData()
    },
    editTemplateFrameTabProp (newVal) {
      this.selectedEditFrameTab = newVal
    },
    tagsSummaryForSuggestionsProp: {
      handler (newVal) {
        this.tagsSummaryForSuggestions = newVal
      },
      deep: true
    }
  },
  mixins: [CommonOptionsMixin, UnsavedDataMixin, AuthMixin],
  data () {
    return {
      FONT_WEIGHT_BOLD,
      FONT_WEIGHT_REGULAR,
      FONT_ITALIC,
      FONT_NORMAL,
      editedProperties: [],
      error: '',
      cityOptions: [],
      cityOptionsSearchLoading: false,
      currentSelectedLogoType: null,
      selectedEditFrameTab: this.editTemplateFrameTabProp,
      mediaListDialog: {
        isVisible: false,
        menuItemId: '',
        filterType: '',
        filterTypeOptions: [this.$utils.options.mediaFileType.img, this.$utils.options.mediaFileType.video],
        mediaSelection: []
      },
      menu: this.$utils.clone(this.projectTemplateProp._edit.menu),
      menuItems: this.$utils.clone(this.projectTemplateProp._edit.menu[this.projectTemplateProp._edit.menu.menuItemsSourceKey]),
      menuData: this.$utils.clone(this.projectTemplateProp._edit.data),
      menuDataSourceKey: this.$utils.clone(this.projectTemplateProp._edit.data.dataSourceKey),
      projectTemplateAction: this.projectTemplateActionProp,
      projectTemplate: this.projectTemplateProp,
      projectOrientation: 'horizontal',
      setOptions: this.$utils.clone(this.projectTemplateProp._edit.setOptions),
      screenIndex: this.screenIndexProp,
      timeZone: [],
      predefineColors: ['#f5977d', '#fcc58e', '#fff69f', '#a4d29e', '#7eccc7', '#72d0f4', '#a088bd', '#f29cc1', '#c6b19a', '#ffffff',
        '#f06d54', '#f9ae64', '#fff372', '#7ec379', '#2abab3', '#00afec', '#8561a6', '#ee70a9', '#988676', '#cccccc',
        '#eb212e', '#f59331', '#fff02a', '#40b34f', '#00a89c', '#0057a4', '#65318f', '#ea148c', '#726258', '#959595',
        '#9c0f17', '#f0662f', '#ab9f1d', '#007138', '#00736a', '#003670', '#441461', '#9c005d', '#534741', '#464646',
        '#780002', '#9e4218', '#827a0d', '#005727', '#005951', '#002355', '#310049', '#790046', '#36302e', '#000000'
      ],
      googleMapSessionToken: null,
      googleMapAutoComplete: {
        isAutocompleteRequestDone: false,
        isPlaceDetailsRequest: false,
        sessionToken: null,
        freshSessionToken: false
      },
      countMenuItemsWithExtendedFlag: 0,
      extendedButtonAction: true,
      tagsSummaryForSuggestions: this.tagsSummaryForSuggestionsProp,
      disabledEditTagItems: [],
      mediaListTagSliderLedTagItem: null,
      playTimePropertiesForm: {
        values: {
          players: {},
          schedules: [],
          scheduleSelection: [],
          schedulePlaytimeTarget: [],
          playtimeItemsVisible: 'all',
          scheduleNewTarget: {},
          scheduleNewTargetOptions: [],
          scheduleNewTargetDropdownVisible: false,
          scheduleNewTargetIconVisible: false
        }
      },
      showProjectFilterInMediaListModal: false,
      showProjectCustomRSSOption: false,
      productName: CONFIG.PRODUCT_NAME
    }
  },
  computed: {
    defaultMediaDurationFormatted () {
      return this.$utils.formatDurationToMinutesAndSeconds({
        duration: this.projectTemplate.alert === true
          ? this.$utils.options.mediaDuration.DEFAULT_ALERT_SEC
          : this.$utils.options.mediaDuration.DEFAULT_MEDIA_SEC
      });
    },
    isProjectTemplateFromPDFFile () {
      const { templateId, templateSetId, dependencyId } = this.projectTemplate

      return templateId === 'playlist' && templateSetId === 'default' && dependencyId
    },
    ...mapState(useGlobalStore, {
      countdownPropertyTimeFormat: 'preferredTimeFormat'
    })
  },
  methods: {
    /**
     * When the cursor leaves the input field without completely filling out all the blanks (_), replace all with zeros (0).
     * If value does not meet the minimum requirement (10 seccs), replace it with the default minimum
     * @param {Event}
     */
    onFocusOut (e) {
      this.menuData[this.menuDataSourceKey][this.screenIndex].settings.dur = e
    },
    onComplete (e, id) {
      this.handleMenuItemChange(e, 'string', 'dur', id)
    },
    filterOutByPropertyName (properties, name) {
      return properties.filter(itemProperty => itemProperty.name !== name)
    },
    filterByPropertyName (properties, name) {
      return properties.filter(
        itemProperty => {
          return (
            itemProperty.type === 'string' &&
            !Object.hasOwn(itemProperty, 'textarea') &&
            itemProperty.name === name
          )
        })
    },
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('menu-edit-template-change', { action, payload: { data } })
      }
    },
    getLEDTagValueFromQuery () {
      const ledTags = this.$filtersRepository.findLedTags(true)
      const videowallTags = this.$filtersRepository.findVideowallTags(true)
      let res = ''

      if (!_.isEmpty(ledTags)) {
        res = ledTags[0]
      } else if (!_.isEmpty(videowallTags)) {
        res = videowallTags[0]
      }

      return res
    },
    setDefaultData (projectTemplateData) {
      if (typeof projectTemplateData === 'object' && projectTemplateData !== null) {
        const newProjectTemplate = this.$utils.clone(projectTemplateData)

        /**
          * Need to convert some data item values such as:
          * - bacgkroundColor: color picker has an issue in alpha value using hex 8 notation format so better to feed color picker component a rgba format
        */
        const dataSource = newProjectTemplate._edit.data[newProjectTemplate._edit.data.dataSourceKey]
        newProjectTemplate._edit.data[newProjectTemplate._edit.data.dataSourceKey] = this.convertProjectDataItemValue(dataSource, 'backendToUI')

        this.projectTemplate = newProjectTemplate
        this.menu = this.$utils.clone(newProjectTemplate._edit.menu)
        this.menuItems = this.$utils.clone(newProjectTemplate._edit.menu[newProjectTemplate._edit.menu.menuItemsSourceKey])
        this.menuData = this.$utils.clone(newProjectTemplate._edit.data)
        this.menuDataSourceKey = newProjectTemplate._edit.data.dataSourceKey
        this.setOptions = this.$utils.clone(newProjectTemplate._edit.setOptions)
      } else {
        this.timeZone = this.customTimeZone()
        this.projectOrientation = this.$dataStore.getMediaOrientation()
        this.menuItems = [] // Reset menuItems to avoid flicker
      }

      // Set Project type for elementi filter in media list modal
      this.showProjectFilterInMediaListModal = this.$currentUser.hasGroupEnterprise() && this.$currentUser.hasFeatureElementiMedia()
      // Custom RSS option is only available for account
      // that has custom RSS feature enabled
      this.showProjectCustomRSSOption = this.$currentUser.hasFeatureCustomRSS()

      this.setDefaultPlaytimes()
      this.setCityListOptionFromCurrentData()
      this.handleCountMenuItemsWithExtendedFlag()

      // Adjust Radio button width and extended menu items visibility
      this.$nextTick(() => {
        this.handleExtendedMenuItemVisibility('less')
      })

      /**
       * For LED Project
       * Get the value of the LED resolution tag from the query string because the data sent by SVG lacks a designated name, as is the case for videowall.
       * - Editing of LED settings on the right side menu must be disabled
       * - LED tag must be added to the Media Picker's list of tags for filtering.
       */
      if (projectTemplateData && projectTemplateData.led) {
        const ledTag = this.getLEDTagValueFromQuery()

        if (!_.isEmpty(ledTag)) {
          this.setLEDTagEditingDisabled(ledTag)
          this.appendLEDTagToMediaPicker(ledTag)
        }
      }
    },
    setLEDTagEditingDisabled (ledTag) {
      this.disabledEditTagItems = [ledTag]
    },
    appendLEDTagToMediaPicker (ledTag) {
      this.mediaListTagSliderLedTagItem = ledTag
    },
    isItemInEditMode (menuItem) {
      if (menuItem.id) {
        return this.menuData[this.menuDataSourceKey][this.screenIndex][menuItem.id] && this.menuData[this.menuDataSourceKey][this.screenIndex][menuItem.id].editmode
      }

      return false
    },
    getEffectPropsFromMenuItem (menuItem) {
      if (menuItem.properties) {
        return menuItem.properties.filter((prop) => ['effectDir', 'effectName'].includes(prop.name))
      }

      return []
    },
    /**
      * This is will get menu item data from data object property source
      * @param {string} item id - the menu item being selected
      * @returns {object} value
    */
    getMenuItemDataFromDataObject (menuItemId) {
      const data = this.$utils.clone(this.menuData)
      const itemData = data[this.menuDataSourceKey][this.screenIndex][menuItemId]

      return itemData
    },
    /**
      * Get current template language per page
    */
    getCurrentTemplateLanguage () {
      const getLanguageMenuVal = this.getMenuItemDataFromDataObject('display')

      return (getLanguageMenuVal) ? getLanguageMenuVal.locale : 'en'
    },
    /**
      * This is will update menu item data in data object source
      * @param {Object} newMenuItemData - updated menu item data
      * @param {string} menuItemId - menuItemId/propertyId
    */
    updateMenuItemDataInDataObject (newMenuItemData, menuItemId) {
      const menuData = this.$utils.clone(this.menuData)
      menuData[this.menuDataSourceKey][this.screenIndex][menuItemId] = newMenuItemData
      this.menuData = menuData
    },
    updateMenuItems (newMenuItems) {
      this.menuItems = newMenuItems
    },
    handleMenuWrapperOnClick ($event) {
      const hasTagInEditMode = $('#projectTemplateMenu').find('.input-new-tag').length

      // Should return the orignal event if tag has an editMode to execute input events
      if (hasTagInEditMode) {
        return $event.originalEvent()
      }

      // By default, onClick event is disabled to control the sending of postMessage into the SVG.
      return $event.stopPropagation()
    },
    handleMenuItemMultiPropertyClick (menuItemKey, propKey) {
      const menuItems = this.$utils.clone(this.menuItems)
      menuItems[menuItemKey]._arrayProperties.selectedPropertyKey = propKey

      this.updateMenuItems(menuItems)
    },
    handleMenuItemMultiPropertyDeleteClick (menuItemKey, menuItemId, dataPropKey) {
      const itemData = this.getMenuItemDataFromDataObject(menuItemId)
      itemData.splice(dataPropKey, 1)

      // Update Menu Data
      const menuData = this.$utils.clone(this.menuData)
      menuData[this.menuDataSourceKey][this.screenIndex][menuItemId] = itemData
      this.menuData = menuData

      /*
        If the Property Key that was being deleted is less than the Selected Property Key then we need to update the
         Menu Item Property Selected key to be minus 1 because of splice.
      */
      const menuItems = this.$utils.clone(this.menuItems)
      if (dataPropKey < menuItems[menuItemKey]._arrayProperties.selectedPropertyKey) {
        menuItems[menuItemKey]._arrayProperties.selectedPropertyKey = (menuItems[menuItemKey]._arrayProperties.selectedPropertyKey - 1)

        this.updateMenuItems(menuItems)
      }

      this.handleProjectPreview(true)
    },
    /**
      * This will add new sub property into menu item (array type of properties)
      * @param {Number} menuItemKey - Parent menu item key or index from the list
      * @param {String} menuItemId - Parent menu item Id
      * @param {Number} max - maximum number of sub properties required
    */
    handleAddMoreSubPropertyInMenuItemClick (menuItemKey, menuItemId, max) {
      const menuItemData = this.getMenuItemDataFromDataObject(menuItemId) // Get the selected Menu Item current data

      if (menuItemData.length < max) {
        /*
          Let's clone the last property from the current menuItemData to have our new property model
          then set an empty value and push to the current menuItemData
        */
        const newItemPropertyData = this.$utils.clone(menuItemData[menuItemData.length - 1])
        for (const indx in newItemPropertyData) {
          newItemPropertyData[indx] = ''
        }
        menuItemData.push(newItemPropertyData)

        this.updateMenuItemDataInDataObject(menuItemData, menuItemId) // Update Menu Data

        // Set the new created sub-property as selected
        const itemDataLastIndex = (menuItemData.length - 1)
        const menuItems = this.$utils.clone(this.menuItems)

        menuItems[menuItemKey]._arrayProperties.selectedPropertyKey = itemDataLastIndex
        this.updateMenuItems(menuItems) // Update Menu Items List
      }
    },
    openMediaPickerDialog (menuItemId) {
      if (!menuItemId) return
      const mediaItemData = this.getMenuItemDataFromDataObject(menuItemId) || {}
      const mediaItemDataType = mediaItemData.type ? mediaItemData.type : 'img'

      // Create media type options
      let mediaTypeOptions = [this.$utils.options.mediaFileType.img, this.$utils.options.mediaFileType.video]

      // Remove video type from options if page already have a video.Multiple videos is not allowed per page.
      if (this.isPageHasMediaTypeVideo() && mediaItemDataType !== this.$utils.options.mediaFileType.video) {
        mediaTypeOptions = mediaTypeOptions.filter(m => m !== this.$utils.options.mediaFileType.video)
      }

      // Remove video type from options if mediatable
      if (menuItemId.includes('mediatable_id') || menuItemId.includes('wayfinding_id') || menuItemId === 'overlay') {
        mediaTypeOptions = mediaTypeOptions.filter(m => m !== this.$utils.options.mediaFileType.video)
      }

      const setOptions = this.setOptions
      const mediaListDialog = this.mediaListDialog
      mediaListDialog.menuItemId = menuItemId
      mediaListDialog.filterTypeOptions = mediaTypeOptions
      mediaListDialog.filterType = mediaItemDataType
      mediaListDialog.mediaSelection = [mediaItemData]
      mediaListDialog.isVisible = true

      /* If Media Dialog is for Logo or Overlay */
      if (mediaItemData.id === 'logo' || menuItemId === 'overlay') {
        mediaListDialog.filterType = (this.currentSelectedLogoType !== null) ? this.currentSelectedLogoType : 'img'
        mediaListDialog.mediaSelection = [setOptions.logo]
      }

      this.mediaListDialog = mediaListDialog
      this.projectOrientation = this.$dataStore.getMediaOrientation()
    },
    /**
      * Hook function if media list dialog sub-component will throw an event or change
      * @param {Object} event - event details
    */
    handleMediaListChange (event) {
      if (event.action === 'MEDIA_SELECTION') {
        const insertToProject = (mediaSelectionSrc) => {
          const mediaSelection = this.$utils.clone(mediaSelectionSrc)
          let media = mediaSelection.length > 0 ? mediaSelection[0] : null

          /* If Media Dialog is for Logo or Overlay Menu Item */
          if (['logo', 'overlay'].includes(this.mediaListDialog.menuItemId)) {
            // If No Media is being selected then get the original value of the logo as default
            if (media === null) {
              media = this.projectTemplate.setOptions.logo
            }

            const newLogo = {
              resourceId: media.resourceId,
              href: media.preview.url,
              preview: media.preview,
              name: media.name,
              width: media.width,
              height: media.height,
              type: media.type
            }

            if (media.preview.status) {
              newLogo.status = media.preview.status
            }

            if (this.menuData?.pages?.length) {
              // Set newLogo to data.pages under overlay:media
              const overlayPageIndex = this.menuData.pages.findIndex(page => !_.isEmpty(page['overlay:media']) || !_.isEmpty(page.overlay))
              if (overlayPageIndex > -1) {
                this.menuData.pages[overlayPageIndex]['overlay:media'] = this.$utils.clone(newLogo)
              }
            }

            this.handleProjectPreview(true)

            this.currentSelectedLogoType = media.type
          } else {
            const originalMediaData = this.getMenuItemDataFromDataObject(this.mediaListDialog.menuItemId)

            // Use the original media data from current page if new media is empty
            if (!media) {
              media = originalMediaData
              media.preview = {
                url: media.href,
                type: 'img'
              }
            }

            // Update media data before adding into selected page
            const menuItemData = this.$utils.clone(media)
            menuItemData.href = media.preview.url

            // Update media status
            if (media.preview.status) {
              menuItemData.status = media.preview.status
            }

            // Keep the previous extended media properties
            const extendedMediaProps = ['kenBurns', 'keepSize', 'mediaFit', 'mediaAlign', 'mediaType', 'fixedDur']
            for (const targetKey of extendedMediaProps) {
              if (_.has(originalMediaData, targetKey)) {
                menuItemData[targetKey] = originalMediaData[targetKey]
              }
            }

            this.updateMenuItemDataInDataObject(menuItemData, this.mediaListDialog.menuItemId)

            // Update Project Preview
            this.handleProjectPreview(true)
          }

          this.handleResetDialog()
        }

        const getMediaResolutionForProject = (mediaSelectionSrc) => {
          const mediaSelection = this.$utils.clone(mediaSelectionSrc)
          const isPDFFile = (mediaSelection[0].name && mediaSelection[0].name.split('.').pop() === 'pdf')
          const isNewUploadedFile = mediaSelection[0]._newUploadMedia
          const getMediaWidth = 1280
          const params = {
            dir: this.$dataStore.getMediaOrientation().toLowerCase(),
            width: getMediaWidth,
            use_qsa: 1
          }
          this.$utils.mainLoader(true)
          this.$api.get(`${CONFIG.API_BASE_URL}/media/${mediaSelection[0].resourceId}`, { params })
            .then(response => {
              const updatedMedia = response.data
              updatedMedia._edit = { selected: false }

              /**
                * For PDF file to avoid empty preview
                * If new upload, Adjust the resourceId with -1 to show first image
                * If file already exist with pages, use the first preview under pages
              */
              if (isNewUploadedFile && isPDFFile) {
                updatedMedia.resourceId = `${updatedMedia.resourceId}-1`
              } else if ((!isNewUploadedFile && isPDFFile) && (updatedMedia.pages && updatedMedia.pages.length)) {
                const firstPage = updatedMedia.pages[0]
                const getPreview = firstPage.preview ? firstPage.preview : null
                const getWidth = firstPage.width ? firstPage.width : null
                const getHeight = firstPage.height ? firstPage.height : null
                const getResourceId = firstPage.resourceId ? firstPage.resourceId : null

                if (getPreview) updatedMedia.preview = getPreview
                if (getWidth) updatedMedia.width = getWidth
                if (getWidth) updatedMedia.height = getHeight
                if (getResourceId) updatedMedia.resourceId = getResourceId
              }

              insertToProject([updatedMedia])
              this.$utils.mainLoader(false)
            })
            .catch((error) => {
              this.error = error.message
              this.$utils.mainLoader(false)
              this.$apiError.handleAPIRequestError(error, { originalRequest: () => { getMediaResolutionForProject() }, showDialogNotification: true })
            })
        }

        if (event.payload.data.length) {
          getMediaResolutionForProject(event.payload.data)
        }
      }
    },
    /**
      * Handle Menu Item City dropdown Element onChange
      * @param {Object} event - dropdown value
    */
    handleMenuItemCityChange (event, actionType) {
      if (actionType === 'localeChanged') {
        const eventSrc = this.$utils.clone(event)

        eventSrc.location = null
        this.googleMapSessionToken = uuidv4()

        event = eventSrc
      }

      if (event.location) {
        const itemData = this.getMenuItemDataFromDataObject('locations')
        this.updateMenuItemDataInDataObject(itemData, 'locations')

        return
      }

      if (this.googleMapSessionToken !== null && event.placeId) {
        const apiRequest = () => {
          const templateLanguage = this.getCurrentTemplateLanguage()
          const reqFields = 'fields=address_component,adr_address,alt_id,formatted_address,geometry,name,type,place_id'
          const placeCityDetailsUrl = `${CONFIG.API_FEEDS_URL}/weather/place/details/json?placeid=${event.placeId}&type=geocode&language=${templateLanguage}&sessiontoken=${this.googleMapSessionToken}&${reqFields}`

          this.emitEvent('MENU_ITEM_REQUEST_START', { name: 'getPlaceDetailsRequest' })

          // Get City Details from Google API
          this.$api.get(placeCityDetailsUrl)
            .then(response => {
              const responseData = {
                addressComponents: (response.data.result.address_components) ? response.data.result.address_components : null,
                geometry: (response.data.result.geometry) ? response.data.result.geometry : null,
                formattedAddress: (response.data.result.formatted_address) ? response.data.result.formatted_address : null,
                id: (response.data.result.id) ? response.data.result.id : null
              }

              // Get name and country
              // Prio -> sublocality -> locality -> country
              const acceptedTypeForCountry = ['country']
              let name = null
              let country = null

              for (const addressComponent of responseData.addressComponents) {
                if (addressComponent.types) {
                  for (const indx in addressComponent.types) {
                    const addressCompType = addressComponent.types[indx]

                    if (name === null && addressCompType === 'sublocality') {
                      name = addressComponent.long_name
                    }

                    if (name === null && addressCompType === 'locality') {
                      name = addressComponent.long_name
                    }

                    if (name === null && addressCompType === 'postal_town') {
                      name = addressComponent.long_name
                    }

                    if (name === null && addressCompType === 'country') {
                      name = addressComponent.long_name
                    }

                    if (acceptedTypeForCountry.indexOf(addressCompType) >= 0) {
                      country = addressComponent.long_name
                    }
                  }
                }
              }

              const getLocationCode = OpenLocationCode.encode(responseData.geometry.location.lat, responseData.geometry.location.lng)

              // Update Menu Item Data
              const itemData = this.getMenuItemDataFromDataObject('locations')
              itemData.name = name
              itemData.fullname = `${name}, ${country}`
              itemData.location = getLocationCode
              itemData.description = responseData.formattedAddress
              this.updateMenuItemDataInDataObject(itemData, 'locations')
              this.handleProjectPreview(true)

              // Update cityOptions Data
              const cityOptions = this.$utils.clone(this.cityOptions)
              for (const city of cityOptions) {
                if (city.placeId === itemData.placeId) {
                  city.name = itemData.name ?? itemData.description
                  city.fullname = itemData.fullname
                  city.location = itemData.location
                  city.description = itemData.description
                }
              }

              this.googleMapSessionToken = null
              this.cityOptions = cityOptions
              this.emitEvent('MENU_ITEM_REQUEST_DONE', { name: 'getPlaceDetailsRequest' })
            })
            .catch((error) => {
              this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
              this.emitEvent('MENU_ITEM_REQUEST_DONE', { name: 'getPlaceDetailsRequest' })
            })
        }

        apiRequest()
      }
    },
    async handleSwitchValueChange (value, menuDataSourceKey, screenIndex, menuItemId, groupedPropItemName, groupedPropItemType) {
      this.menuData[menuDataSourceKey][screenIndex][menuItemId][groupedPropItemName] = value
      await this.$nextTick()
      this.handleMenuItemChange(value, groupedPropItemType, groupedPropItemName, menuItemId)
    },
    handleDateTimeValueChange (value, menuItemId, propName) {
      this.menuData[this.menuDataSourceKey][this.screenIndex][menuItemId][propName] = value
      this.handleMenuItemChange(value)
    },
    /**
      * Handle Menu Item Element onChange
    */
    handleMenuItemChange (event, type, name, menuItemId) {
      console.log('*** MENU CHANGE TRIGGERED: TYPE=', type, 'NAME=', name, 'MENU ID=', menuItemId, 'EVENT=', event)

      if (type === 'choice' && name === 'locale') {
        const getCurrentLocations = this.getMenuItemDataFromDataObject('locations')

        this.handleMenuItemCityChange(getCurrentLocations, 'localeChanged')
      } else if (type === 'tags') {
        if (event.action === 'TAGS_UPDATED' || event.action === 'TAG_REMOVED') {
          // Update Menu Item Data
          let itemData = this.getMenuItemDataFromDataObject('tags')
          itemData = event.payload.data.tags
          this.updateMenuItemDataInDataObject(itemData, 'tags')
          this.handleProjectPreview(true)
        }
      } else if (type === 'schedulePlaytimes') {
        if (event.action === 'PLAYTIMES_UPDATED') {
          let itemData = this.getMenuItemDataFromDataObject('playTimes')
          itemData = event.payload.data.playtimes
          this.updateMenuItemDataInDataObject(itemData, 'playTimes')
          this.handleProjectPreview(true)
        }
      } else if (type === 'string' && name === 'dur') {
        const itemData = this.getMenuItemDataFromDataObject('settings')
        itemData.dur = this.$utils.formatDurationToMinutesAndSeconds({ duration: this.$utils.convertDurationToSeconds(event) })
        this.updateMenuItemDataInDataObject(itemData, 'settings')
        this.handleProjectPreview(true)
      } else if (type === 'string' && name === 'href' && menuItemId) {
        const itemData = this.getMenuItemDataFromDataObject(menuItemId)
        let isInvalidLink = false

        if (itemData.mediaType !== 'stream') { // skip checks for streaming urls
          // Prepend protocol if not present
          if (!itemData.href.startsWith('http://') && !itemData.href.startsWith('https://')) {
            itemData.href = `https://${itemData.href}`
          }

          // Check if url is correct
          try {
            const url = new URL(itemData.href)

            if (!url.hostname) {
              isInvalidLink = true
            } else if (itemData.mediaType !== 'stream' && url.protocol !== 'https:' && url.protocol !== 'http:') {
              isInvalidLink = true
            }
          } catch (err) {
            isInvalidLink = true
          }
        }

        // Add error property if invalid link
        if (isInvalidLink) {
          itemData.error = {
            name: 'invalid-link',
            message: this.$t('template.error.invalidLink')
          }
        } else {
          delete itemData.error
        }

        this.updateMenuItemDataInDataObject(itemData, menuItemId)
        this.handleProjectPreview(true)
      } else if (menuItemId === 'rss' && name === 'rssLang') {
        const itemData = this.getMenuItemDataFromDataObject('rss')
        const menuItem = this.menuItems.find((item) => item.id === menuItemId)

        if (!menuItem) {
          itemData.url = ''
          this.updateMenuItemDataInDataObject(itemData, menuItemId)

          return
        }

        const urlProperty = menuItem.properties?.find((item) => item.name === 'url')

        if (urlProperty) {
          const urls = urlProperty.values.filter((item) => item.lang === menuItem.selectedLang)

          itemData.url = urls.length > 0 ? urls[0].value : ''
        }

        this.updateMenuItemDataInDataObject(itemData, menuItemId)
        this.handleProjectPreview(true)
      } else if (type === 'switch' && name === 'fontBold') {
        /**
         * Skip bold toggle if font family only has bold/heavy weights available.
         *
         * Edge case: Some fonts only provide weights >= 700 (e.g., only Bold, ExtraBold, Black).
         * In such cases, there's no regular weight to toggle to, so the bold button should have no effect.
         * This prevents attempting to switch to a non-existent regular (400) weight.
         */
        const currentMenuItem = this.menuItems.find(item => item.id === menuItemId)
        if (!currentMenuItem) return;

        const fontWeightProperties = currentMenuItem.properties?.find(prop => prop.name === 'fontWeight')
        const areAllFontWeightsBold = fontWeightProperties?.values.every(font => Number(font.value) >= Number(FONT_WEIGHT_BOLD))

        if (areAllFontWeightsBold) return;

        const currentFontWeight = this.menuData[this.menuDataSourceKey][this.screenIndex][menuItemId].fontWeight
        const previousFontWeight = this.menuData[this.menuDataSourceKey][this.screenIndex][menuItemId].previousFontWeight ?? FONT_WEIGHT_REGULAR
        const currentFontWeightNum = Number(currentFontWeight)
        const previousFontWeightNum = Number(previousFontWeight)
        const boldThreshold = Number(FONT_WEIGHT_BOLD)

        /**
         * Toggle font weight between bold/regular while preserving user's last selection:
         *
         * When currently bold (>= 700):
         *   - If previous weight was heavier than bold (e.g., 800, 900), revert to regular (400)
         *   - Otherwise, restore the previous lighter weight (e.g., 300, 400, 500, 600)
         *
         * When currently non-bold (< 700):
         *   - If previous weight was heavier than bold (e.g., 800, 900), restore that heavier weight
         *   - Otherwise, switch to standard bold (700)
         */
        let newFontWeight
        if (currentFontWeightNum >= boldThreshold) {
          // Currently bold: toggle to lighter weight
          newFontWeight = previousFontWeightNum >= boldThreshold ? FONT_WEIGHT_REGULAR : previousFontWeight
        } else {
          // Currently non-bold: toggle to heavier weight
          newFontWeight = previousFontWeightNum >= boldThreshold ? previousFontWeight : FONT_WEIGHT_BOLD
        }

        const newMenuItemData = {
          ...this.menuData[this.menuDataSourceKey][this.screenIndex][menuItemId],
          fontWeight: newFontWeight,
          previousFontWeight: currentFontWeight
        }

        this.updateMenuItemDataInDataObject(newMenuItemData, menuItemId)
        this.handleProjectPreview(true)
      } else if (type === 'switch' && name === 'fontStyle') {
        const currentFontStyle = this.menuData[this.menuDataSourceKey][this.screenIndex][menuItemId].fontStyle
        let newFontStyle = FONT_ITALIC

        if (currentFontStyle === FONT_ITALIC) {
          newFontStyle = FONT_NORMAL
        }

        const newMenuItemData = {
          ...this.menuData[this.menuDataSourceKey][this.screenIndex][menuItemId],
          fontStyle: newFontStyle
        }

        this.updateMenuItemDataInDataObject(newMenuItemData, menuItemId)
        this.handleProjectPreview(true)
      } else if (type === 'choice' && name === 'fontWeight') {
        const currentFontWeight = this.menuData[this.menuDataSourceKey][this.screenIndex][menuItemId].fontWeight

        const newMenuItemData = {
          ...this.menuData[this.menuDataSourceKey][this.screenIndex][menuItemId],
          fontWeight: event.toString(),
          previousFontWeight: currentFontWeight
        }

        this.updateMenuItemDataInDataObject(newMenuItemData, menuItemId)
        this.handleProjectPreview(true)
      } else {
        this.handleProjectPreview(true)
      }

      // Set Unsaved Changes
      this.setUnsavedDataFlagIntoLocalstorage({ page: 'editProject' })
    },
    handleMenuItemEffectsChange (eventValue, name, menuItemId) {
      const newMenuItemData = { ...this.menuData[this.menuDataSourceKey][this.screenIndex][menuItemId] }
      const orientationProperties = ['horizontal', 'vertical', 'custom']

      // If orientation properties are present, delete effects properties under it
      orientationProperties.forEach((orientation) => {
        if (_.has(newMenuItemData, orientation)) {
          delete newMenuItemData[orientation].effectName
          delete newMenuItemData[orientation].effectDir
        }
      })

      newMenuItemData[name] = eventValue
      this.updateMenuItemDataInDataObject(newMenuItemData, menuItemId)
      this.handleProjectPreview(true)
    },
    /**
      * Handle Color Swatches Change
      * @param {String} valueRgb
      * @param {String} propertyId
      * @param {String} model
    */
    handleColorSwatchChange (valueRgb, model, attribute) {
      // NOTE: short-circuit undefined valueRgb
      if (!valueRgb) {
        return
      }

      if (model) {
        model[attribute] = valueRgb
      }

      this.handleMenuItemChange(valueRgb)
    },
    /**
      * Handle Menu Item Element onChange, specific for Number
      * @param {Number} value
      * @param {String} menuItemId
      * @param {String} menuItemPropertyName
    */
    handleMenuItemNumberChange (value, menuItemId, menuItemPropertyName) {
      const itemData = this.getMenuItemDataFromDataObject(menuItemId)

      itemData[menuItemPropertyName] = value

      this.updateMenuItemDataInDataObject(itemData, menuItemId)

      this.handleProjectPreview(true)

      // Set Unsaved Changes
      this.setUnsavedDataFlagIntoLocalstorage({ page: 'editProject' })
    },
    /**
      * This will send an event to the parent component to have a project preview
      * @param {Boolean} autoApplyDataChanges - Auto apply data changes into the original project data
    */
    handleProjectPreview (autoApplyDataChanges) {
      const projectTemplate = this.$utils.clone(this.projectTemplate)
      const previewData = { data: [], setOptions: {} }

      if (projectTemplate._edit.projectType === 'multiplePage') {
        previewData.data.pages = this.convertProjectDataItemValue(this.menuData[this.menuDataSourceKey], 'UIToBackend')
      }

      // Set Options
      previewData.setOptions = this.setOptions
      this.emitEvent('PROJECT_TEMPLATE_PREVIEW', previewData)

      // Apply data changes
      if (typeof (autoApplyDataChanges) === 'boolean' && autoApplyDataChanges) {
        this.handleApplyingOfDataChanges()
      }
    },
    handleResetDialog () {
      this.mediaListDialog = { isVisible: false, menuItem: '' }
    },
    handleDialogClose () {
      this.mediaListDialog.isVisible = false
      EventBus.$emit('MEDIA_PICKER_CLOSED')

      if (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)) {
        $('.project-frame-content').removeClass('hide-project-iframe')
      }
    },
    /**
      * This will send an event to the parent component to update the original project template object
    */
    handleApplyingOfDataChanges () {
      const projectTemplate = this.$utils.clone(this.projectTemplate)

      if (projectTemplate._edit.projectType === 'multiplePage') {
        projectTemplate.data.pages = this.convertProjectDataItemValue(this.menuData[this.menuDataSourceKey], 'UIToBackend')
      }

      // Set Options
      projectTemplate.setOptions = this.setOptions
      projectTemplate._edit.menu[projectTemplate._edit.menu.menuItemsSourceKey] = this.menuItems
      this.emitEvent('PROJECT_TEMPLATE_APPLY_DATA_CHANGES', _.cloneDeep(projectTemplate))
    },
    handleSubmittingOfProjectIntoAPI (formRef) {
      let requestData = this.$utils.clone(this.projectTemplate)
      delete requestData._edit

      // Create Poroject Template
      if (this.projectTemplateAction === 'createNewProjectTemplate') {
        const apiRequest = () => {
          this.$utils.mainLoader(true)

          requestData = this.$utils.filterProjectDataForBackend({ project: requestData })
          this.$api.post(`${CONFIG.API_BASE_URL}/project`, requestData)
            .then(response => {
              this.emitEvent('NEW_PROJECT_TEMPLATE_CREATED', response.data)
              this.$router.push(`/project-edit/${response.data.resourceId}`, () => {})
              this.$utils.mainLoader(false)
            })
            .catch((error) => {
              this.$utils.mainLoader(false)
              this.$apiError.handleAPIRequestNormalError(error, { originalRequest: () => { apiRequest() }, showDialogNotification: true })
            })
        }
        apiRequest()
      }

      // Edit Project Template
      if (this.projectTemplateAction === 'editProjectTemplate') {
        const apiRequest = () => {
          this.$utils.mainLoader(true)

          requestData = this.$utils.filterProjectDataForBackend({ project: requestData })
          this.$api.put(`${CONFIG.API_BASE_URL}/project/${requestData.resourceId}`, requestData)
            .then(response => {
              this.emitEvent('PROJECT_TEMPLATE_UPDATED', response.data)
              this.$utils.mainLoader(false)
            })
            .catch((error) => {
              this.$utils.mainLoader(false)
              this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
            })
        }
        apiRequest()
      }
    },

    /**
      * Handle align element context menu updates.
      * This will send an event to the parent component
      * to send a command message `align`.
      * @param {Object<{xAlign:string, yAlign:string}>} alignElementsData
    */
    handleAlignElementChange (alignElementsData) {
      this.emitEvent('ALIGN_ELEMENTS', alignElementsData)
    },
    setDefaultPlaytimes () {
      const menuData = this.$utils.clone(this.menuData)
      const screenData = menuData[menuData.dataSourceKey][this.screenIndex]
      const playTimePropertiesForm = this.$utils.clone(this.playTimePropertiesForm)

      playTimePropertiesForm.values.scheduleSelection = [{
        custom: screenData ? screenData.playTimes : [],
        type: 'custom',
        order: 1,
        target: this.screenIndex
      }]

      this.playTimePropertiesForm = playTimePropertiesForm
    },
    /**
      * This will set City options based from current Template Screen/Page data(locations). This is a workaround to
      * display the city name in the selectbox instead of cityId.
    */
    setCityListOptionFromCurrentData () {
      const menuData = this.$utils.clone(this.menuData)
      const screenData = menuData[menuData.dataSourceKey][this.screenIndex]

      if ((typeof screenData === 'object' && screenData !== null) && screenData.locations) {
        this.cityOptions = [screenData.locations]
      }
    },
    /**
      * Handle City Search on city selectbox change
      * @param {String} - cityName
    */
    handleCityOptionsSearch (cityNameInput) {
      const apiRequest = () => {
        this.cityOptionsSearchLoading = true

        // Generate a session token
        if (this.googleMapSessionToken === null) {
          this.googleMapSessionToken = uuidv4()
        }
        const templateLanguage = this.getCurrentTemplateLanguage()
        const placeAutoCompleteUrl = `${CONFIG.API_FEEDS_URL}/weather/place/autocomplete/json?input=${cityNameInput}&type=(cities)&language=${templateLanguage}&sessiontoken=${this.googleMapSessionToken}`

        // Get Search City from Google API
        this.$api.get(placeAutoCompleteUrl)
          .then(response => {
            const searchResults = []
            const acceptedTypes = ['locality', 'sublocality', 'colloquial_area', 'administrative_area_level_1', 'administrative_area_level_2', 'administrative_area_level_3', 'administrative_area_level_4']

            for (const item of response.data.predictions) {
              if (item.types) {
                for (const indx in item.types) {
                  if (acceptedTypes.indexOf(item.types[indx]) >= 0) {
                    item.placeId = item.place_id
                    searchResults.push({
                      ...item,
                      name: item.name ?? item.description
                    })
                    break
                  }
                }
              }
            }

            this.cityOptions = searchResults
            this.cityOptionsSearchLoading = false
          })
          .catch((error) => {
            this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
          })
      }

      apiRequest()
    },
    handleCountMenuItemsWithExtendedFlag () {
      let countPropertiesWithExtendedFlag = 0

      for (const indx in this.menuItems) {
        const menuItem = this.menuItems[indx]

        if (menuItem.properties) {
          for (const iPropIndx in menuItem.properties) {
            if (menuItem.properties[iPropIndx].extended) {
              countPropertiesWithExtendedFlag += 1
            }
          }
        }
      }
      this.countMenuItemsWithExtendedFlag = countPropertiesWithExtendedFlag
    },
    handleExtendedMenuItemVisibility (actionType) {
      if (actionType === 'more') {
        $('.extended-menu-item').each((indx, el) => {
          $(el).show()
          $(el).parents().eq(2).css({ marginTop: '8px' })
        })

        this.extendedButtonAction = 'less'
      }

      if (actionType === 'less') {
        $('.extended-menu-item').each((indx, el) => {
          $(el).hide()
          $(el).parents().eq(2).css({ marginTop: '0px' })
        })

        this.extendedButtonAction = 'more'
      }
    },
    getColorPickerPopperClass (itemProperty) {
      let popperClass = 'custom-color-picker-dropdown'

      if ((itemProperty.name === 'backgroundColor')) {
        popperClass = `${popperClass} show-rgba-to-hex-input`
      }

      return popperClass
    },
    handleTimePickerFocus (menuItemId, itemPropertyName) {
      // If empty then set a default value.Use xx:00 as default if current minute is not available from the options
      const getDefaultValue = () => {
        if ((moment().format('mm') % 10) !== 0) {
          return moment().set({ minute: 0 }).format('HH:mm')
        }
        return moment().format('HH:mm')
      }

      if (this.menuData[this.menuDataSourceKey][this.screenIndex][menuItemId][itemPropertyName] === '' || this.menuData[this.menuDataSourceKey][this.screenIndex][menuItemId][itemPropertyName] === null) {
        this.menuData[this.menuDataSourceKey][this.screenIndex][menuItemId][itemPropertyName] = getDefaultValue()
      }
    },
    handleInputElFocus (elementRef) {
      // Select all text on focus
      if (this.$refs[elementRef] && this.$refs[elementRef][0]) this.$refs[elementRef][0].select()
    },
    /**
     * For instances when there's a separate property for duration.
     * If there is it should be skipped to avoid unnecessary duration rendered in the UI
     * @param {[]} properties
     * @returns boolean
     */
    ifOnlyDurationInProperty (properties) {
      return properties.length === 1 && properties.find((prop) => prop.name === 'dur')
    },
    isPageHasMediaTypeVideo () {
      const pageData = this.menuData[this.menuDataSourceKey][this.screenIndex]
      let res = false

      for (const [key, value] of Object.entries(pageData)) {
        if (key.includes('media') && _.isObject(value) && value.type === this.$utils.options.mediaFileType.video) {
          res = true
          break
        }
      }

      return res
    },
    isMediaItem (menuItemId) {
      return menuItemId.includes('media') && !menuItemId.includes('mediatable')
    },
    isOverlayItem (menuItemId) {
      return menuItemId === 'overlay'
    },
    isWarningItem (menuItemId) {
      return menuItemId === 'warning'
    },
    isMediaItemAsLogo (menuItem) {
      return menuItem.style === 'logo'
    },
    isElementiMedia (menuItemId) {
      const itemType = this.getMenuItemDataFromDataObject(menuItemId)?.type ?? ''
      return itemType === this.$utils.options.mediaFileType.elementi
    },
    isImageMedia (menuItemId) {
      const itemType = this.getMenuItemDataFromDataObject(menuItemId)?.type ?? ''
      return itemType === this.$utils.options.mediaFileType.img
    },
    isVideoMedia (menuItemId) {
      const itemType = this.getMenuItemDataFromDataObject(menuItemId)?.type ?? ''
      return itemType === this.$utils.options.mediaFileType.video
    },
    isMediaEffectsProperties (itemProperty, mediaItemId) {
      return this.isImageMedia(mediaItemId) && ['kenBurns'].includes(itemProperty.name)
    },
    isMediaEffectsPropertiesVisible (itemProperty) {
      // Hide kenBurns effects in project alert as not yet supported
      if (itemProperty.name === 'kenBurns' && this.projectTemplate.alert === true) {
        return false
      }

      return true
    },
    isMediaVideoSettingsProperties (itemProperty) {
      return ['fixedDur'].includes(itemProperty.name)
    },
    isMediaFittingProperties (itemProperty) {
      return !['fixedDur', 'kenBurns'].includes(itemProperty.name)
    },
    isMediaStream (menuItemId) {
      const itemType = this.getMenuItemDataFromDataObject(menuItemId)?.type ?? ''
      return itemType === 'stream'
    },
    isMediaStreamHasURL (menuItem) {
      return menuItem.properties && !_.isEmpty(menuItem.properties.find(item => item.type === 'string' && item.name === 'href'))
    },
    // Function only called by parent component to handle hiding the colorpickers on new selection
    closeColorPickers () {
      if (this.$refs.colorPicker) {
        this.$refs.colorPicker.map(instance => instance.hide())
      }
    },
    resetDateTimeValue (menuItemId, propName) {
      this.handleDateTimeValueChange(null, menuItemId, propName)
    },
    getNearestFontWeightValue (fontWeightValues, targetFontWeight) {
      let nearestValue = fontWeightValues[0]
      let smallestDifference = Math.abs(targetFontWeight - nearestValue)

      for (const value of fontWeightValues) {
        const difference = Math.abs(targetFontWeight - value)
        if (difference < smallestDifference) {
          smallestDifference = difference
          nearestValue = value
        }
      }

      return nearestValue
    },
    getFontWeightName (menuItemId) {
      const fontWeightValue = this.menuData[this.menuDataSourceKey][this.screenIndex][menuItemId]?.fontWeight

      const fontWeightProperty = this.menuItems.find(item => item.id === menuItemId)?.properties?.find(prop => prop.name === 'fontWeight')

      if (fontWeightProperty) {
        const fontWeightOption = fontWeightProperty.values.find(option => option.value.toString() === fontWeightValue?.toString())

        // If font weight value is not in the list of properties, get nearest value from regular (400)
        if (!fontWeightOption) {
          const fontWeightValues = fontWeightProperty.values.map(option => Number(option.value))
          const nearestFontWeightValue = this.getNearestFontWeightValue(fontWeightValues, Number(fontWeightValue))
          const nearestFontWeightOption = fontWeightProperty.values.find(option => Number(option.value) === nearestFontWeightValue)

          return nearestFontWeightOption ? nearestFontWeightOption.name : fontWeightValue
        }
      }

      return this.menuData[this.menuDataSourceKey][this.screenIndex][menuItemId]?.fontWeight;
    }
  },
  mounted () {
    this.setDefaultData()
  }
}
